import React from "react";
import TableStyles from "../../../../styles/components/TableStyles";
import { TermoHistorico } from "../../../../context/interfaces/IAdministratorTachContext";

interface ITableInformation {
    historyTerm: TermoHistorico[];
}

const actual = "ATUAL";
const before = "ANTERIOR";

const TableInformation: React.FC<ITableInformation> = ({ historyTerm }) => {
    const sortedList = [...historyTerm].sort((a, b) => {
        if (a.priority === before && b.priority === actual) {
            return -1;
        }
        if (a.priority === actual && b.priority === before) {
            return 1;
        }
        return 0;
    });

    const formatNumberToTwoDecimalPlaces = (number: number): string => {
        const formattedNumber = number.toFixed(2);
        return formattedNumber.replace(".", ",");
    };

    const getTotalHistoryTerm = (
        letivaBase: number,
        naoLetivaBase: number,
        horaLetivaEventual: number,
        horaNaoLetivaEventual: number,
        horaLetivaSubstituicao: number,
        horaNaoLetivaSubstituicao: number
    ): number => {
        return (
            letivaBase +
            naoLetivaBase +
            horaLetivaEventual +
            horaNaoLetivaEventual +
            horaLetivaSubstituicao +
            horaNaoLetivaSubstituicao
        );
    };

    const getClassName = (value: number) => {
        if (value < 0) return "negative-value";

        if (value > 0) return "positive-value";

        return "";
    };

    const getCalculatedDifferences = () => {
        const totalDifference = {
            letivaBase: 0,
            naoLetivaBase: 0,
            horaLetivaEventual: 0,
            horaNaoLetivaEventual: 0,
            horaLetivaSubstituicao: 0,
            horaNaoLetivaSubstituicao: 0,
        };

        for (let i = 0; i < sortedList.length - 1; i++) {
            const current = sortedList[i];
            const next = sortedList[i + 1];

            totalDifference.letivaBase += next.letivaBase - current.letivaBase;
            totalDifference.naoLetivaBase +=
                next.naoLetivaBase - current.naoLetivaBase;
            totalDifference.horaLetivaEventual +=
                next.horaLetivaEventual - current.horaLetivaEventual;
            totalDifference.horaNaoLetivaEventual +=
                next.horaNaoLetivaEventual - current.horaNaoLetivaEventual;
            totalDifference.horaLetivaSubstituicao +=
                next.horaLetivaSubstituicao - current.horaLetivaSubstituicao;
            totalDifference.horaNaoLetivaSubstituicao +=
                next.horaNaoLetivaSubstituicao -
                current.horaNaoLetivaSubstituicao;
        }

        const totalHistoryTerm = getTotalHistoryTerm(
            totalDifference.letivaBase,
            totalDifference.naoLetivaBase,
            totalDifference.horaLetivaEventual,
            totalDifference.horaNaoLetivaEventual,
            totalDifference.horaLetivaSubstituicao,
            totalDifference.horaNaoLetivaSubstituicao
        );

        return (
            <tr>
                <th>Ajustes</th>
                <td className={getClassName(totalDifference.letivaBase)}>
                    {formatNumberToTwoDecimalPlaces(totalDifference.letivaBase)}
                </td>
                <td className={getClassName(totalDifference.naoLetivaBase)}>
                    {formatNumberToTwoDecimalPlaces(
                        totalDifference.naoLetivaBase
                    )}
                </td>
                <td
                    className={getClassName(totalDifference.horaLetivaEventual)}
                >
                    {formatNumberToTwoDecimalPlaces(
                        totalDifference.horaLetivaEventual
                    )}
                </td>
                <td
                    className={getClassName(
                        totalDifference.horaNaoLetivaEventual
                    )}
                >
                    {formatNumberToTwoDecimalPlaces(
                        totalDifference.horaNaoLetivaEventual
                    )}
                </td>
                <td
                    className={getClassName(
                        totalDifference.horaLetivaSubstituicao
                    )}
                >
                    {formatNumberToTwoDecimalPlaces(
                        totalDifference.horaLetivaSubstituicao
                    )}
                </td>
                <td
                    className={getClassName(
                        totalDifference.horaNaoLetivaSubstituicao
                    )}
                >
                    {formatNumberToTwoDecimalPlaces(
                        totalDifference.horaNaoLetivaSubstituicao
                    )}
                </td>
                <td className={getClassName(totalHistoryTerm)}>
                    {formatNumberToTwoDecimalPlaces(totalHistoryTerm)}
                </td>
            </tr>
        );
    };

    return (
        <TableStyles.TablePrimary
            bordered
            responsive
            background
            className="no-border"
            style={{ margin: "25px 0" }}
        >
            <thead className="text-align-right">
                <tr>
                    <th> </th>
                    <th>Letivas</th>
                    <th>Não Letivas</th>
                    <th>Eventuais Letivas</th>
                    <th>Eventuais Não Letivas</th>
                    <th>Substituições Letivas</th>
                    <th>Substituições Não Letivas</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody className="text-align-right">
                {sortedList.length ? (
                    sortedList.map((row) => (
                        <tr>
                            <th>{`Termo ${row.ano} ${row.semestre}`}</th>
                            <td>
                                {formatNumberToTwoDecimalPlaces(row.letivaBase)}
                            </td>
                            <td>
                                {formatNumberToTwoDecimalPlaces(
                                    row.naoLetivaBase
                                )}
                            </td>
                            <td>
                                {formatNumberToTwoDecimalPlaces(
                                    row.horaLetivaEventual
                                )}
                            </td>
                            <td>
                                {formatNumberToTwoDecimalPlaces(
                                    row.horaNaoLetivaEventual
                                )}
                            </td>
                            <td>
                                {formatNumberToTwoDecimalPlaces(
                                    row.horaLetivaSubstituicao
                                )}
                            </td>
                            <td>
                                {formatNumberToTwoDecimalPlaces(
                                    row.horaNaoLetivaSubstituicao
                                )}
                            </td>
                            <td>
                                {formatNumberToTwoDecimalPlaces(
                                    getTotalHistoryTerm(
                                        row.letivaBase,
                                        row.naoLetivaBase,
                                        row.horaLetivaEventual,
                                        row.horaNaoLetivaEventual,
                                        row.horaLetivaSubstituicao,
                                        row.horaNaoLetivaSubstituicao
                                    )
                                )}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td style={{ textAlign: "center" }} colSpan={8}>
                            Informações indisponíveis.
                        </td>
                    </tr>
                )}
                {sortedList.length ? getCalculatedDifferences() : null}
            </tbody>
        </TableStyles.TablePrimary>
    );
};

export default TableInformation;
